export type Environment = "production" | "staging" | "development"

const ALLOWED_APP_ENVS: readonly Environment[] = [
  "production",
  "staging",
  "development",
]

// Driven by an explicit per-deploy var so build mode (NODE_ENV) and target
// environment stay independent — `next dev` against staging data should
// still render the staging banner.
//
// Falls back to NODE_ENV only for the local-dev case so a fresh checkout
// with no .env file renders the development banner instead of silently
// claiming to be production.
export const getEnvironment = (): Environment => {
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV
  if (appEnv && ALLOWED_APP_ENVS.includes(appEnv as Environment)) {
    return appEnv as Environment
  }
  return process.env.NODE_ENV === "production" ? "production" : "development"
}
